import request from '@/utils/request'

export function fetchCardGroupList (query) {
  return request({
    url: '/card/api/card_group/index',
    method: 'get',
    params: query
  })
}

export function getSwitchableCard (query) {
  return request({
    url: '/card/api/card_group/getSwitchableCard',
    method: 'get',
    params: query
  })
}

export function createCardGroup (data) {
  return request({
    url: '/card/api/card_group/insert',
    method: 'post',
    data
  })
}

export function updateCardGroup (data) {
  return request({
    url: '/card/api/card_group/update',
    method: 'post',
    data
  })
}

export function deleteCardGroup (id) {
  return request({
    url: '/card/api/card_group/delete',
    method: 'post',
    params: { id }
  })
}

export function cardGroupCheckAllocation (batchId) {
  return request({
    url: '/card/api/card_group/checkAllocation',
    method: 'post',
    params: { batch_id: batchId }
  })
}

export function cardGroupCheckReset (batchId) {
  return request({
    url: '/card/api/card_group/checkReset',
    method: 'post',
    params: { batch_id: batchId }
  })
}

export function cardGroupAllocation (groupId, batchId, agentId, clientId) {
  return request({
    url: '/card/api/card_group/allocation',
    method: 'post',
    params: { group_id: groupId, batch_id: batchId, agent_id: agentId, client_id: clientId }
  })
}

export function cardGroupRecharge (groupId, productId) {
  return request({
    url: '/card/api/card_group/package_add',
    method: 'post',
    params: { group_id: groupId, product_id: productId }
  })
}

export function cardGroupReset (groupId, batchId) {
  return request({
    url: '/card/api/card_group/reset',
    method: 'post',
    params: { group_id: groupId, batch_id: batchId }
  })
}

export function exportApply (query) {
  return request({
    url: '/card/api/card_group/export',
    method: 'get',
    params: query
  })
}

export function offlineExportApply (query) {
  return request({
    url: '/card/api/card_group/offline_export',
    method: 'get',
    params: query
  })
}

export function fetchCardGroupPackages (query) {
  return request({
    url: '/card/api/card_group/packages',
    method: 'get',
    params: query
  })
}

export function fetchDeletedCardGroupPackages (query) {
  return request({
    url: '/card/api/card_group/deleted_packages',
    method: 'get',
    params: query
  })
}

export function deleteCardGroupPackage (data) {
  return request({
    url: '/card/api/card_group/packageDelete',
    method: 'post',
    data: data
  })
}

export function updateCardGroupPackage (data) {
  return request({
    url: '/card/api/card_group/packageUpdate',
    method: 'post',
    data: data
  })
}

export function bind (data) {
  return request({
    url: '/card/api/card_group/bind',
    method: 'post',
    params: data
  })
}

export function unbind (data) {
  return request({
    url: '/card/api/card_group/unbind',
    method: 'post',
    params: data
  })
}

export function replaceDevice (data) {
  return request({
    url: '/card/api/card_group/replace',
    method: 'post',
    params: data
  })
}

export function apiDeletePackage (data) {
  return request({
    url: '/card/api/card_group/apiDeletePackage',
    method: 'post',
    params: data
  })
}

export function apiRecoverPackage (data) {
  return request({
    url: '/card/api/card_group/apiRecoverPackage',
    method: 'post',
    params: data
  })
}

export function deletePackage (data) {
  return request({
    url: '/card/api/card_group/replace',
    method: 'post',
    params: data
  })
}

export function postpone (data) {
  return request({
    url: '/card/api/card_group/postpone',
    method: 'post',
    params: data
  })
}

export function upgradePackage (data) {
  return request({
    url: '/card/api/card_group/upgradePackage',
    method: 'post',
    data: data
  })
}

export function factoryReset (data) {
  return request({
    url: '/card/api/card_group/factoryReset',
    method: 'post',
    data: data
  })
}

export function switchDeviceNetwork (data) {
  return request({
    url: '/card/api/card_group/switchDeviceNetwork',
    method: 'post',
    data: data
  })
}

export function updateCardGroupUsage (data) {
  return request({
    url: '/card/api/card_group/updateCardGroupUsage',
    method: 'post',
    data: data
  })
}

export function balanceRecharge (data) {
  return request({
    url: '/card/api/card_group/balanceRecharge',
    method: 'post',
    data: data
  })
}

export function changeState (data) {
  return request({
    url: '/card/api/card_group/changeState',
    method: 'post',
    data: data
  })
}

export function catelog (id, catelogId) {
  return request({
    url: '/card/api/card_group/catelog',
    method: 'post',
    data: {id, catelogId}
  })
}



// WEBPACK FOOTER //
// ./src/card/api/card-group.js